export const neighborhoodCard = {
  inTotal: '共',
  registoryCount: `{registoryCount}个户型`,
  noImage:"图片拍摄中"
};